var render = function render(){var _vm=this,_c=_vm._self._c;return _c('riskWarn',{attrs:{"domain":"ar","pageTitle":"应收暂支未清预警","themeColor":"#2E7BFF","subTabs":['客户应收未清', '暂支未清'],"showAmount":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }